import { IResortPathInfo } from '@/api/resort/types';
import { Routes } from '@/routes';
import { PlanYourTrip } from './Component';
import { OuterPlanYourTripPropsType } from './types';
import { hasWeSkiIntegration, weSkiDestinationId } from './WeSki/resolver';

interface IRegionPlanYourTripProps extends OuterPlanYourTripPropsType {
  resort: IResortPathInfo,
  templateName?: string,
  isCondensed?: boolean,
}

const PlanYourTripResortWrapper = ({
  resort, templateName, isCondensed, ...props
}: IRegionPlanYourTripProps) => {
  const redirectSkiRentalPath = Routes.resortSkiRentals(resort);
  const { title_short: title } = resort;

  // Only WeSki lodging is available after the TripAdvisor retirement.
  // Pass `undefined` when there's no WeSki integration so PlanYourTrip
  // simply hides the lodging tab content.
  const hasWeSki = hasWeSkiIntegration({ resortId: resort.uuid });
  const lodgingProvider = hasWeSki ? 'weski' : undefined;
  const weDestinationId = hasWeSki ? weSkiDestinationId({ resortId: resort.uuid }) : null;

  return (
    <PlanYourTrip
      {...props}
      contextKey="resort"
      title={title}
      redirectSkiRentalPath={redirectSkiRentalPath}
      lodgingProvider={lodgingProvider}
      weSkiDestinationId={weDestinationId}
      templateName={templateName}
      isCondensed={isCondensed}
      resortId={resort.uuid}
    />
  );
};

export default PlanYourTripResortWrapper;
